import React from 'react';
import { motion } from 'framer-motion';
import { AwardIcon, CheckIcon, XIcon } from 'lucide-react';
import { systemNegatives, totalBonuses, totalVolumes } from '../data/offer';
export function SystemSection() {
  return <section className="bg-mist py-16 sm:py-20" aria-labelledby="system-title" data-id="element-233" data-mp="3bhljv43cc8l2">
      <div className="mx-auto max-w-4xl px-4 text-center" data-id="element-234" data-mp="36kle6uael7uh">
        <span className="inline-flex items-center gap-2 rounded-full bg-navy px-4 py-2 text-xs font-extrabold uppercase tracking-[.15em] text-white" data-id="element-235" data-mp="36m676fh2kiq8">
          <AwardIcon className="h-4 w-4 text-solar" aria-hidden="true" data-id="element-236" data-mp="2wsxr15kvqcyt" /> The most comprehensive environmental
          management teaching system in the world
        </span>
        <h2 id="system-title" className="mx-auto mt-5 max-w-3xl text-balance text-3xl font-extrabold text-navy sm:text-4xl" data-id="element-237" data-mp="2ntu8c2pmjzku">
          Environmental Management Teacher Ready
        </h2>
        <p className="mt-3 font-semibold text-muted" data-id="element-238" data-mp="2dveie32c2wcx">
          {totalVolumes} volumes · {totalBonuses} exclusive bonuses · Everything you need to teach environmental
          management with confidence.
        </p>

        <ul className="mx-auto mt-10 grid max-w-3xl gap-3 text-left sm:grid-cols-3" data-id="element-239" data-mp="18q6hcj0o62xx">
          {systemNegatives.map(item => <motion.li key={item} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.28,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex gap-3 rounded-lg border border-line bg-white p-4 text-sm font-semibold text-muted" data-id="element-240" data-mp="u2lfesfj69rl">
              <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-danger" aria-hidden="true" data-id="element-241" data-mp="1cqi1lup4e18v" />
              {item}
            </motion.li>)}
        </ul>

        <p className="mx-auto mt-8 flex max-w-3xl items-start gap-3 rounded-xl border border-leaf/30 bg-leafSoft p-6 text-left text-lg font-bold leading-relaxed text-navy" data-id="element-242" data-mp="1ccvav1fpfad">
          <CheckIcon className="mt-1 h-6 w-6 shrink-0 text-leaf" aria-hidden="true" data-id="element-243" data-mp="69czt1imy9zd" />
          It's a complete system so you can enter the classroom with confidence and deliver lessons that truly teach how
          to understand, assess, and respond to environmental challenges.
        </p>
      </div>
    </section>;
}